import type { PublicAgent } from '@killer-party/contracts';

// Compte a rebours « mm:ss », ou « hh:mm:ss » au-dela d'une heure.
export function formatCountdown(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const minutesSeconds = `${twoDigits(minutes)}:${twoDigits(seconds)}`;
  return hours > 0 ? `${twoDigits(hours)}:${minutesSeconds}` : minutesSeconds;
}

// Nombre sur deux chiffres, comme sur les compteurs des maquettes (07, 12).
export function twoDigits(value: number): string {
  return String(value).padStart(2, '0');
}

// Identifiant public d'operation tire d'un lien colle ou saisi tel quel.
export function extractPublicId(input: string): string | null {
  const value = input.trim();
  if (!value) {
    return null;
  }
  if (!value.includes('/')) {
    return value;
  }
  return /\/operations\/([^/?#\s]+)/.exec(value)?.[1] ?? null;
}

// Valeur d'un champ datetime-local (heure locale, a la minute) pour un instant ISO.
export function toDateTimeLocal(iso: string | null): string {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  const day = [date.getFullYear(), twoDigits(date.getMonth() + 1), twoDigits(date.getDate())].join(
    '-',
  );
  return `${day}T${twoDigits(date.getHours())}:${twoDigits(date.getMinutes())}`;
}

// Instant ISO saisi dans un champ datetime-local, null si le champ est vide.
export function fromDateTimeLocal(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}

// Agent nomme dans un texte : nom de code, puis prenom pour distinguer les homonymes (TD-029).
export function agentName(agent: PublicAgent): string {
  return `${agent.codeName} (${agent.firstName})`;
}
